import { styled } from 'styletron-react';
import { evaluateSpacingsStyle } from './helpers/evaluateSpacingsStyle';
export const StyledLayoutBase = styled('div', ({ $spacing, $spacingHorizontal, $spacingVertical, $spacingTop, $spacingRight, $spacingBottom, $spacingLeft, $fullWidth, $fullHeight, $width, $minWidth, $maxWidth, $height, $minHeight, $maxHeight, $grow, $basis, $shrink, $opacity, $overflow, $zIndex, $alignSelf, $justifySelf, }) => {
    return {
        ...evaluateSpacingsStyle({
            $spacing,
            $spacingHorizontal,
            $spacingVertical,
            $spacingTop,
            $spacingRight,
            $spacingBottom,
            $spacingLeft,
        }),
        width: $width ?? ($fullWidth ? '100%' : undefined),
        height: $height ?? ($fullHeight ? '100%' : undefined),
        minWidth: $minWidth,
        maxWidth: $maxWidth,
        minHeight: $minHeight,
        maxHeight: $maxHeight,
        flexGrow: $grow,
        flexBasis: $basis,
        flexShrink: $shrink,
        opacity: $opacity,
        overflow: $overflow,
        zIndex: $zIndex,
        alignSelf: $alignSelf,
        justifySelf: $justifySelf,
    };
});
export const layoutBasePropsToStyledProps = ({ spacing, spacingHorizontal, spacingVertical, spacingTop, spacingRight, spacingBottom, spacingLeft, fullWidth, fullHeight, width, minWidth, maxWidth, height, minHeight, maxHeight, grow, basis, shrink, opacity, overflow, zIndex, alignSelf, justifySelf, }) => ({
    $spacing: spacing,
    $spacingHorizontal: spacingHorizontal,
    $spacingVertical: spacingVertical,
    $spacingTop: spacingTop,
    $spacingRight: spacingRight,
    $spacingBottom: spacingBottom,
    $spacingLeft: spacingLeft,
    $fullWidth: fullWidth,
    $fullHeight: fullHeight,
    $opacity: opacity,
    $width: width,
    $minWidth: minWidth,
    $maxWidth: maxWidth,
    $height: height,
    $minHeight: minHeight,
    $maxHeight: maxHeight,
    $grow: grow,
    $basis: basis,
    $shrink: shrink,
    $overflow: overflow,
    $zIndex: zIndex,
    $alignSelf: alignSelf,
    $justifySelf: justifySelf,
});
